import { Component } from '@angular/core';
import { TabComponent } from '../tab/tab.component';
import { TabsComponent } from '../tabs/tabs.component';

@Component({
  selector: 'app-tab-selector',
  template: `
    <ul>
      <li *ngFor="let tab of tabs" (click)="selectTab(tab)">
        {{ tab.identifier }}
      </li>
    </ul>
  `,
})
export class TabSelectorComponent {
  tabs: TabComponent[] = [];

  constructor(tabs: TabsComponent) {
    this.tabs = tabs.tabs;
  }

  selectTab(tab: TabComponent) {
    this.deactivateAllTabs();

    tab.active = true;
  }

  deactivateAllTabs(): void {
    this.tabs.forEach((tab: TabComponent) => {
      tab.active = false;
    });
  }
}
